import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UiErrorParser } from '../ui-error-parser';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable()
export class PrestadorErrorParser extends UiErrorParser {
    private prestadorBasePath = SICOM_PATHS.registro.prestador.base;
    private prestadorReportsPath = SICOM_PATHS.registro.prestador.reports.base;
    private prestadorDadosGeraisPath = SICOM_PATHS.registro.prestador.dadosGerais;
    private prestadorDiretoriaPath = SICOM_PATHS.registro.prestador.diretoria;
    private prestadorDocumentosPath = SICOM_PATHS.registro.prestador.documentos;

    constructor() {
        super();
        this.setType('prestador');
    }

    /**
     * Emissão de relatório é contexto do {@link RelatorioErrorParser}, que sabe ler a mensagem de
     * regra de negócio no `title` do CfmErrorDto. Como `/cadastro/prestador/reports` também casa
     * com o path base do módulo, a exclusão é explícita para não depender da ordem de registro
     * dos parsers em `app.config.ts`.
     */
    override verifyContext(error: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
        if (req.url.includes(this.prestadorReportsPath)) {
            return false;
        }
        return req.url.includes(this.prestadorBasePath) && error.status !== 0;
    }

    override beforeTextBuild(error: HttpErrorResponse, req: HttpRequest<unknown>): void {
        const detail = this.extractErrorMessage(error);
        if (detail) {
            const isClientBusinessError = error.status >= 400 && error.status < 500;
            this.setTitle(isClientBusinessError ? 'Atenção' : 'Erro');
            this.setSeverity(isClientBusinessError ? 'warn' : 'error');
            this.setMessageStart(detail);
            this.setMethod('');
            this.setTarget('');
            return;
        }

        this.setMessageStart('Não foi possível');
        this.setTarget(this.resolveTarget(req.url));
    }

    override errorComplement(_error: HttpErrorResponse, _req: HttpRequest<unknown>): string {
        return '';
    }

    private resolveTarget(url: string): string {
        if (url.includes(this.prestadorDadosGeraisPath)) {
            return 'os dados gerais do prestador';
        }
        if (url.includes(this.prestadorDiretoriaPath)) {
            return 'a diretoria do prestador';
        }
        if (url.includes(this.prestadorDocumentosPath)) {
            return 'os documentos do prestador';
        }
        return 'o cadastro do prestador';
    }
}
